import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function BlogList() {
  const navigate = useNavigate();

  // Redirect to the most recent blog post
  useEffect(() => {
    navigate(`/blog/new-site-launch`); // Redirect to the most recent blog (first one in the list)
  }, [navigate]);

  return null; // This page is just a redirect, so we don't need to render anything here
}
